const isProduction = process.env.APP_ENV === 'production';
const isVerbose = process.env.AUTH_LOG_VERBOSE === 'true';

export const authLogger = {
  log: (...args: unknown[]) => {
    if (!isProduction && isVerbose) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (!isProduction) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    console.error(...args);
  },
};
